<template>
    <div class="gz_dock">
        <div class="dock">
            <div style="width: 50vw;height: 2vw;background-color: rgb(6, 2, 65);position: absolute;top: 2vw;left: 25%;"></div>
            <iframe style="width: 100vw;height: 100vh;border: 3px solid #2c348a;border-radius: 8px;" :src="src"></iframe>
        </div>
    </div>
</template>

<script>
import request from '@/utils/request';

export default {
    name: 'index',
    data() {
        return {
            src: ''
        };
    },
    mounted() {
        this.fnGetUrl();
    },
    methods: {
        // 获取今日考勤数据
        fnGetUrl() {
            request({
                url: 'project_gzs/getDockingSituationUrl',
                method: 'GET'
            })
                .then(res => {
                    if (res.data) {
                        this.src = res.data;
                    }
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        }
    }
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.gz_dock {
    width: 1920px;
    height: 858px;
    position: relative;
    overflow: hidden;
    .dock {
        position: absolute;
        left: 0;
        right: -20px;
        top: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
        padding-top: 25px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/GzDockingSituation/index.vue